import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    options: {
      type: Object,
      default() {
        return {};
      }
    },
    interval: { type: Number, default: 1440 },
    max: { type: Number, default: undefined }
  },
  watch: {
    max() {
      this.updateChart();
    },
    interval() {
      this.updateChart();
    }
  },
  mounted() {
    this.updateChart();
  },
  methods: {
    updateChart() {
      this.renderChart(
        this.chartData,
        Object.assign(
          {
            tooltips: {
              position: "nearest",
              mode: "index",
              intersect: false,
              callbacks: {
                label: function(tooltipItem, data) {
                  var label =
                    data.datasets[tooltipItem.datasetIndex].label || "";

                  if (label) {
                    label += ": ";
                  }
                  label += Math.round(tooltipItem.yLabel * 100) / 100;
                  return label;
                }
              }
            },
            scales: {
              xAxes: [
                {
                  display: true,
                  type: "time",
                  time: {
                    parser: "DD.MM.YYYY HH:mm",
                    tooltipFormat: "DD.MM.YYYY HH:mm",
                    unit: "day",
                    unitStepSize: Math.max(
                      1,
                      Math.floor((this.interval || 1440) / 1440)
                    ),
                    displayFormats: {
                      day: "DD.MM.YYYY"
                    }
                  }
                }
              ],
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                    max: this.max
                  }
                }
              ]
            }
          },
          this.options
        )
      );
    }
  }
};
